import { BreadCrumbs } from '../../../../components/BreadCrumbs/breadCrumbrs'
import { i18n } from '../../../../translate/i18n'
import { Loading } from '../../../../components/Loading/Loading'
import { useParams } from 'react-router-dom'
import { FC, useEffect } from 'react'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { useUsers } from '../factory/useUsers'
import { UserCardGrid } from '../components/UserCardGrid'
import { useSwaggerRoutes } from '../factory/useSwaggerRoutes'


const SwaggerPermissionContent: FC = () => {
    const { id } = useParams()

    const { users, setLoading, getUsers , loading } = useUsers(id || '')
    const {getSwaggerRoutes, swaggerRoutes} = useSwaggerRoutes()

    async function loadPage() {
        setLoading(true)
        await getUsers()
        await getSwaggerRoutes()
        setLoading(false)
    }

    useEffect(() => {
        loadPage()
    }, [])

    if (loading) {
        return <Loading />
    }


    return (
        <div className='row g-5 gx-xxl-12'>
            <div className='card card-xxl-stretch mb-5 mb-xl-12'>
                <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-3 mb-1'>
                            {i18n.t(`swagger.title_user`)}
                        </span>
                        <BreadCrumbs />
                        <span className='text-muted mt-1 fw-bold fs-7 w-75'>
                            {i18n.t(
                                `swagger.subTitle_user`
                            )}
                        </span>
                    </h3>


                </div>

                <div className='card-body'>
                    <UserCardGrid users={users} routes={swaggerRoutes} />    
                </div>
            </div>
        </div>
    )
}


const SwaggerPermissionGiver: FC = () => {
    return (
        <>
            <PageTitle
                breadcrumbs={[
                    { title: 'Swagger Permissions', path: 'swagger_permissions', isActive: true },
                    { title: 'Swagger Permissions Giver', path: 'swagger_permissions/pluginspace/:id', isActive: true },
                ]}
            >
                Swagger Permissions
            </PageTitle>
            <SwaggerPermissionContent />
        </>
    )
}

export { SwaggerPermissionGiver }